import { Flex } from 'antd';
import styles from '../navbar.module.scss';
import logo from './../../../assets/logos/elevate_logo_landing.svg';
import { Button } from '../../../common';

const Navbar = () => {
  return (
    <Flex justify="center" align="center" className={styles.navbarWrapper}>
      <Flex justify="space-between" align="center" className={styles.navbar}>
        <img className={styles.logo} src={logo} alt="" />
        <a href="tel:+18336692112" style={{ textDecoration: 'none' }}>
          <Button
            style={{
              height: '40px',
              borderRadius: '8px',
              paddingInline: '16px',
            }}
            className="primary-button body-14-semibold"
          >
            Call Now
          </Button>
        </a>
      </Flex>
    </Flex>
  );
};

export default Navbar;
